import { ApplicationConfig, provideZoneChangeDetection, importProvidersFrom, ENVIRONMENT_INITIALIZER, Provider, inject } from '@angular/core';
import { provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { FormlyModule } from '@ngx-formly/core';
import { provideNgxMask } from 'ngx-mask';
import {
  RktFormlyFieldGroupComponent,
  RktFormFieldWrapperComponent,
  RktFormInputComponent,
  RktFormInputPhoneComponent,
  RktFormSelectComponent,
  RktFormInputCardComponent,
  RktFormTextareaComponent,
  RktFormRadioGroupComponent,
  RktFormCheckboxGroupComponent,
  RktFormSelectCountryComponent,
  RktFormSelectStateComponent,
  RktFormInputAddessComponent,
  phoneNumberValidator,
  countryCodeValidator,
  stateCodeValidator,
  requiredValidationMessage,
  minLengthValidationMessage,
} from '@rocketfinancialcorp/rocket-ui/form';
import { RktIconRegistryService, card } from '@rocketfinancialcorp/rocket-ui/icon';
import { routes } from './app.routes';
import { jwtInterceptor } from './shared/interceptors/jwt.interceptor';
import {
  isValidCardNumber,
  isValidExpiryDate,
  isValidInput,
  isDigit,
} from './shared/validators/custom-validator';
import { APP_ENV_CONFIG, getEnvironment } from './shared/services/app.config';

const iconsProvider: () => Provider = () => {
  return {
    provide: ENVIRONMENT_INITIALIZER,
    multi: true,
    useValue: () => inject(RktIconRegistryService).registerIcons([card]),
  };
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideHttpClient(withInterceptors([jwtInterceptor])),
    provideAnimationsAsync(),
    provideNgxMask(),
    { provide: APP_ENV_CONFIG, useFactory: getEnvironment },
    iconsProvider(),
    importProvidersFrom(
      FormlyModule.forRoot({
        types: [
          { name: 'formly-group', component: RktFormlyFieldGroupComponent },
          { name: 'input', component: RktFormInputComponent, wrappers: ['field-wrapper'] },
          { name: 'input-phone', component: RktFormInputPhoneComponent, wrappers: ['field-wrapper'] },
          { name: 'input-card', component: RktFormInputCardComponent, wrappers: ['field-wrapper'] },
          { name: 'input-address', component: RktFormInputAddessComponent, wrappers: ['field-wrapper'] },
          { name: 'select', component: RktFormSelectComponent, wrappers: ['field-wrapper'] },
          { name: 'select-country', component: RktFormSelectCountryComponent, wrappers: ['field-wrapper'] },
          { name: 'select-state', component: RktFormSelectStateComponent, wrappers: ['field-wrapper'] },
          { name: 'textarea', component: RktFormTextareaComponent, wrappers: ['field-wrapper'] },
          { name: 'radio-group', component: RktFormRadioGroupComponent, wrappers: ['field-wrapper'] },
          { name: 'checkbox-group', component: RktFormCheckboxGroupComponent, wrappers: ['field-wrapper'] },
        ],
        wrappers: [{ name: 'field-wrapper', component: RktFormFieldWrapperComponent }],
        validationMessages: [
          { name: 'required', message: requiredValidationMessage },
          { name: 'minLength', message: minLengthValidationMessage },
        ],
        validators: [
          { name: 'isValidPhoneNumber', validation: phoneNumberValidator },
          { name: 'isValidCountryCode', validation: countryCodeValidator },
          { name: 'isValidStateCode', validation: stateCodeValidator },
          { name: 'isValidCardNumber', validation: isValidCardNumber },
          { name: 'isValidExpiryDate', validation: isValidExpiryDate },
          { name: 'isValidInput', validation: isValidInput },
          { name: 'isDigit', validation: isDigit },
        ],
      })
    ),
  ],
};
